import { NotifyError } from 'js/vue/boot/Notify'

export function errorDefault(message, error) {
  console.log(error)
  NotifyError(message)
}
